import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'

import { Divider, Text } from '@reveni-io/reveni-ui'

import CarbonOffsetFeeConfiguration from './CarbonOffsetFeeConfiguration/CarbonOffsetFeeConfiguration'
import ExchangeAddressRestrictionConfiguration from './ExchangeAddressRestrictionConfiguration/ExchangeAddressRestrictionConfiguration'
import { shouldShowAdditionalConfiguration } from './helpers'
import * as Styles from './styles'

const AdditionalConfigurationSection = ({
  config,
  onChange,
  deliveryMethodType,
  subscriptionPlan,
  defaultStoreCurrency,
}) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)

  const handleToggleExpanded = () => setExpanded(current => !current)

  if (!shouldShowAdditionalConfiguration(deliveryMethodType, subscriptionPlan)) {
    return null
  }

  return (
    <>
      <Divider />
      <Styles.Container>
        <Styles.Header type="button" onClick={handleToggleExpanded}>
          <Text type="titleS">{t('Configuración adicional')}</Text>
          {expanded ? <CaretUpIcon size={20} /> : <CaretDownIcon size={20} />}
        </Styles.Header>
        {expanded && (
          <>
            <CarbonOffsetFeeConfiguration
              config={config}
              onChange={onChange}
              defaultStoreCurrency={defaultStoreCurrency}
            />
            <ExchangeAddressRestrictionConfiguration config={config} onChange={onChange} />
          </>
        )}
      </Styles.Container>
    </>
  )
}

export default AdditionalConfigurationSection
